import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import { withTranslation } from 'react-i18next'

import { modal } from 'store/entities/modal/actions'
import { getIdentityActiveRoleName } from 'store/entities/identity/selectors'
import PeerInviteButton from './PeerInviteButton'

const mapDispatchToProps = {
  showModal: modal.show,
}

const mapStateToProps = createStructuredSelector({
  role: getIdentityActiveRoleName,
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation('user')(PeerInviteButton)))
